import ContactInfo from "../ui/ContactComponet";
import { Container, Row } from "../ui/Containers";
import QuirckyInsights from "../ui/QuirkyInsights";
import RockLee from "../ui/RockleeAndQuote";
import { useTheme } from "../../context/ThemeContext";
import SkillsSet from "../ui/SkillSet";
import AnimatedText from "../ui/Animation/AnimatedText";
import Parallax from "../ui/Parallax";
import useMediaQuery from "../../hooks/useMediaQuerryHook";
import PageTransition from "../../utils/TransitionPage";
import { useState } from "react";

const phrase =
  "I design logic and build systems that quietly run the show — turning ideas into powerful backend experiences.";

function About() {
  const { theme } = useTheme();
  const [showTransition, setShowTransition] = useState(true);
  const isSmallScreen = useMediaQuery(576);
  return (
    <>
      {showTransition && (
        <PageTransition onFinish={() => setShowTransition(false)} />
      )}

      {!showTransition && (
        <Container>
          <Row>
            <div className="col-*-* App-col">
              <AnimatedText
                $animTextMargin={`${isSmallScreen ? "5rem" : "2rem"} 0 5rem 0`}
                text={phrase}
                className="heavyText"
              />

              <Parallax>
                <QuirckyInsights />
              </Parallax>
              <Parallax>
                <RockLee />
              </Parallax>
              <Parallax>
                <SkillsSet isDarkMode={theme === "dark"} />
              </Parallax>
            </div>
          </Row>
          <ContactInfo />
        </Container>
      )}
    </>
  );
}

export default About;
